import React from 'react'

const TEMP_TSH = 10 // under 10 degree celsius it's cold

const Temp = ({data}) => {
  return (
    <g>
      <text className='cls-27' transform='translate(1017.6 481.65)'>
        <tspan className='cls-28'>Internal Temp</tspan>
      </text>
      <text className='cls-34' transform='translate(1071.27 467.61)'>UR {data.externalHumidity}%</text>
      <text className={data.internalTemp < TEMP_TSH ? 'cls-35' : 'cls-35'} transform='translate(1015.77 467.61)'>{data.internalTemp}°</text>
      <path id='TERMOMETRO' className={data.internalTemp < TEMP_TSH ? 'cls-36' : 'cls-36'} d='M989.75,461.21V429.67a6.33,6.33,0,1,0-12.66,0V461.2a10.55,10.55,0,1,0,12.67,0Zm-6.33,15.1a6.68,6.68,0,0,1-2.49-12.87V429.87a2.49,2.49,0,1,1,5,0v2.62h-2a.88.88,0,1,0,0,1.76h2v5.06h-2a.88.88,0,1,0,0,1.76h2v4.2h-2a.88.88,0,1,0,0,1.76h2v4.21h-2a.88.88,0,1,0,0,1.76h2v4.2h-2a.88.88,0,1,0,0,1.76h2v4.46a6.68,6.68,0,0,1-2.49,12.87Z' transform='translate(15.14 9.94)' />
      <text className='cls-27' transform='translate(1017.6 264.15)'>External Temp
      </text>
      <text className='cls-34' transform='translate(1071.27 250.11)'>UR {data.internalHumidity}%</text>
      <text className={data.externalTemp < TEMP_TSH ? 'cls-39' : 'cls-76'} transform='translate(1015.77 250.11)'>{data.externalTemp}°</text>
      <path id='TERMOMETRO-2' data-name='TERMOMETRO' className={data.externalTemp < TEMP_TSH ? 'cls-40' : 'cls-77'} d='M989.75,243.71V212.17a6.33,6.33,0,1,0-12.66,0V243.7a10.55,10.55,0,1,0,12.67,0Zm-6.33,15.1a6.68,6.68,0,0,1-2.49-12.87V212.37a2.49,2.49,0,1,1,5,0V215h-2a.88.88,0,1,0,0,1.76h2v5.06h-2a.88.88,0,1,0,0,1.76h2v4.2h-2a.88.88,0,1,0,0,1.76h2v4.21h-2a.88.88,0,1,0,0,1.76h2v4.2h-2a.88.88,0,1,0,0,1.76h2v4.46a6.68,6.68,0,0,1-2.49,12.87Z' transform='translate(15.14 9.94)' />
    </g>
  )
}

export default Temp



// WEBPACK FOOTER //
// ./src/CustomPlot/Temp.js